module.exports = __webpack_public_path__ + "static/media/couponWithQRCode.6d7dc737.jpg";